import { render, staticRenderFns } from "./activitypackagecourse.vue?vue&type=template&id=0be5e0de&"
import script from "./activitypackagecourse.vue?vue&type=script&lang=js&"
export * from "./activitypackagecourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports